import { api } from "../../lib";

export interface BillingScenario {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreateBillingScenarioInput {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateBillingScenarioInput
  extends Partial<CreateBillingScenarioInput> {
  id: string;
}

export const billingScenariosService = {
  getAll: async () => {
    return api.get<BillingScenario[]>("/admin/billing-scenarios");
  },

  getById: async (id: string) => {
    return api.get<BillingScenario>(`/admin/billing-scenarios/${id}`);
  },

  create: async (input: CreateBillingScenarioInput) => {
    return api.post<BillingScenario>("/admin/billing-scenarios", input);
  },

  update: async (input: UpdateBillingScenarioInput) => {
    const { id, ...updates } = input;
    return api.put<BillingScenario>(`/admin/billing-scenarios/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/billing-scenarios/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<BillingScenario>(`/admin/billing-scenarios/${id}`, {
      isActive,
    });
  },
};
